export interface MatchScoreLineOptions {
  wentToPens?: boolean;
  penaltiesHome?: number | null;
  penaltiesAway?: number | null;
}

export interface PenaltyScore {
  home: number;
  away: number;
}

function shouldShowPenalties(
  goalsHome: number,
  goalsAway: number,
  opts?: MatchScoreLineOptions,
): boolean {
  if (opts?.wentToPens) return true;
  if (goalsHome !== goalsAway) return false;
  return opts?.penaltiesHome != null && opts?.penaltiesAway != null;
}

export function formatRegulationScoreLine(goalsHome: number, goalsAway: number): string {
  return `${goalsHome} – ${goalsAway}`;
}

export function formatPenaltyScoreLine(pensHome: number, pensAway: number): string {
  return `(${pensHome} – ${pensAway})`;
}

export function resolvePenaltyScore(
  goalsHome: number,
  goalsAway: number,
  opts?: MatchScoreLineOptions,
): PenaltyScore | undefined {
  if (!shouldShowPenalties(goalsHome, goalsAway, opts)) return undefined;
  return {
    home: opts?.penaltiesHome ?? 0,
    away: opts?.penaltiesAway ?? 0,
  };
}

/** Inline score for compact contexts (e.g. world map). */
export function formatMatchScoreLine(
  goalsHome: number,
  goalsAway: number,
  opts?: MatchScoreLineOptions,
): string {
  const goals = formatRegulationScoreLine(goalsHome, goalsAway);
  if (!shouldShowPenalties(goalsHome, goalsAway, opts)) return goals;

  const pensHome = opts?.penaltiesHome ?? 0;
  const pensAway = opts?.penaltiesAway ?? 0;
  return `${goals} (${pensHome}–${pensAway} pens)`;
}
